import React, {
  useContext, useEffect, useState,
} from 'react';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import { UnitTileProps } from 'src/components/profileComponents/Marketplace/components/UnitsTiles/types';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import {
  IMarketplacePlacementProperty,
  IMarketplacePlacementTileSortOrder,
  sortOrderOptionsFull,
  sortOrderOptionsMapFull,
  SortOrderType,
} from 'src/components/profileComponents/Marketplace/types';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import {
  unitTileIsDefaultOptions,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/constants';
import { useGetDeveloperSpecifications } from 'src/hooks/useGetDeveloperSpecifications';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import Box from '@mui/material/Box';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { IMarketplacePlacementTileSortOrderProperty } from 'src/typings/marketplaceTile';

export const UnitsTile: React.FC<UnitTileProps> = ({
  index, entity, onChange, resetIsDefaultProperties, moveToTrash,
}) => {
  const mainStyles = mainUseStyles();
  const context = useContext(UnitsDataContext);
  const [lang] = React.useState<string>(context?.state.marketplace?.language || '');
  const {
    fetchSpecifications,
  } = useGetDeveloperSpecifications(context?.state.marketplace?.developers[0]);
  const [placementPropertyOptions, setPlacementPropertyOptions] = useState<IDevelopmentSpecificationPropChange<IMarketplacePlacementProperty>[]>([]);

  useEffect(() => {
    fetchSpecifications();
  }, []);

  useEffect(() => {
    if (context) {
      setPlacementPropertyOptions(context.state.marketplace.placementProperties.map((item) => ({ label: item.translates?.[lang] || item.systemName, value: item })));
    }
  }, [context]);

  return (
    <SubGroupWrapper
      name="Sort value"
      onTrash={() => moveToTrash(index)}
      customOffsetStyles={mainStyles.customOffsetStyles}
    >
      <Box display="flex" gap="20px">
        <BoxFormTextField
          label={translations.nameValue}
          name="valueName"
          defaultValue={entity.valueName?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(entity, 'valueName', lang, event.target.value));
          }}
        />
        <BoxFormAutocomplete
          label={translations.propertyName}
          name="propertyName"
          defaultValue={entity.property ? { label: entity.property?.translates?.[lang] || entity.property?.systemName, value: entity.property } : null}
          onChange={(event: IDevelopmentSpecificationPropChange<IMarketplacePlacementTileSortOrderProperty>) => {
            onChange({ ...entity, property: event.value });
          }}
          options={placementPropertyOptions}
        />
        <BoxFormAutocomplete
          label={translations.sortOrder}
          name="property"
          defaultValue={
            entity.sortOrderDirection
              ? {
                label: sortOrderOptionsMapFull[entity.sortOrderDirection],
                value: entity.sortOrderDirection,
              }
              : undefined
          }
          options={sortOrderOptionsFull}
          onChange={(event: IDevelopmentSpecificationPropChange<SortOrderType>) => {
            onChange({ ...entity, sortOrderDirection: event.value });
          }}
        />
        <BoxFormAutocomplete
          label={translations.isDefault}
          name="isDefault"
          value={{ label: entity?.isDefault ? 'Yes' : 'No', value: entity.isDefault }}
          onChange={() => {
            resetIsDefaultProperties(index);
          }}
          options={unitTileIsDefaultOptions}
        />
      </Box>
    </SubGroupWrapper>
  );
};
